import React, { useState, useEffect } from "react";
import "./ModificarArticulo.scss";
import { withRouter } from "react-router-dom";
import { Form, Row, Col, Input, Button, Upload, Radio, Select, message, Alert } from 'antd';
import {  UploadOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import Mensajes from "../Mensajes/Mensajes";
import { base64toBlob, base64ToArrayBuffer } from "../../utils/Utils";
import { getClasificacionesByTipoArt, getTiposEleccionByClasificacion, getArticulo, updateArticulo} from '../../api/configuracon';
import Viewer, { Worker } from '@phuocng/react-pdf-viewer';
import '@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css';
import { useHistory } from "react-router-dom";
import { Tooltip } from '@material-ui/core';
const { Option } = Select;

function ModificarArticulo(props) {

    var tiempoMensaje = 5;
    let history = useHistory();
    const { TextArea } = Input;
    const { getFieldDecorator } = props.form;
    const estadoSel = localStorage.getItem('ID_ESTADO_SELECCIONADO');
    const procesoSel = localStorage.getItem('ID_PROCESO_ELECTORAL');
    const detalleSel = localStorage.getItem('ID_DETALLE_PROCESO');
    const tiposSublcasificacion = [
        { value: 0, label: 'DOCUMENTACION SIN EMBLEMAS', tipoArticulo: 2 },
        { value: 1, label: 'DOCUMENTACION CON EMBLEMAS', tipoArticulo: 2 },
        { value: 2, label: 'BOLETAS', tipoArticulo: 2},
        { value: -1, label: 'SIN CLASIFICACION ADICIONAL', tipoArticulo: 1 },
    ]

    const [loadData,                setLoadData]                = useState(false);
    const [listaClasificaciones,    setListaClasificaciones]    = useState([]);
    const [listaSubclasificaciones, setListaSubclasificaciones] = useState([]);
    const [listaTiposEleccion,      setListaTiposEleccion]      = useState([]);
    const [listaEspTec,             setListaEspTec]             = useState({especificaciones: new Map()});
    const [listaEspDis,             setListaEspDis]             = useState({especificaciones: new Map()});
    const [fileList,                setFileList]                = useState([]);
    const [requiredTieneEmblema,    setRequiredTieneEmblema]    = useState(true)
    const [archivoDisenioUnico,     setArchivoDisenioUnico]     = useState({
        uploading: false,
        file: "",
        urlPDF: null
    });
    const [visibleAlert,             setVisibleAlert]            = useState({
        activado: false,
        tipoMensaje: "",
        mensaje: ""
    });

    useEffect(()=>{
        if(!loadData){
            getDataArticulo();
        }
    }, [loadData]) 
    
    const getDataArticulo = ()=>{
        let data = {
            idProceso: procesoSel,
            idDetalleProceso: detalleSel,
            anio: localStorage.getItem('ANIO'),
            tipoProceso: localStorage.getItem("TIPO_PROCESO"),
            idArticulo: props.idArticulo,
        };
        //Se verifica si el tipo de articulo ya se asignó para que no ejecute la consulta varias veces
        if (props.form.getFieldValue('tipoArticulo') === undefined ){
            //Se consultan los datos del artículo
            getArticulo(data).then((res1)=>{

                const dataArticulo = res1.data.entity;
                //Se carga el archivo al visor de PDF
                let url = null;
                if (dataArticulo.disenioUnicoBase64 !== null && dataArticulo.disenioUnicoBase64 !== "") {
                    const disenioUnicoBase64 = 'data:application/pdf;base64,' + dataArticulo.disenioUnicoBase64;
                    const disenioUnicoBase64Viewer = dataArticulo.disenioUnicoBase64;
                    const blob = base64toBlob(disenioUnicoBase64);
                    url = base64ToArrayBuffer(disenioUnicoBase64Viewer);
                    setArchivoDisenioUnico({uploading:true, file:blob, urlPDF: url})
                }
                //Se asigna el tipo de articulo a la data para consultar los catálogos
                data.idTipoArticulo = dataArticulo.tipoArticulo;
                
                    //Se obtiene la lista de clasificaciones de acuerdo al tipo de Articulo obtenido
                    getClasificacionesByTipoArt(data).then((res2)=>{
                        //se convierte el objeto que retorna el back en un array de objetos
                        const objToArray = Object.entries(res2.data.entity.select).map(([value, label]) => ({
                            value,
                            label
                          }));
                        setListaClasificaciones(objToArray);
                        getTiposEleccionByClasificacion(dataArticulo.clasificacion).then(res3=>{
                            
                            const objToArray = Object.entries(res3.data.entity.select).map(([value, label]) => ({
                                value,
                                label
                              }));
                            setListaTiposEleccion(objToArray);
                            //se asignan los dataArticulo a los elementos de los formularios
                            props.form.setFieldsValue({
                                nombreArticulo: dataArticulo.nombreArticulo,
                                tipoArticulo: dataArticulo.tipoArticulo,
                                tipoClasificacionEleccion: dataArticulo.clasificacion,
                                tipoSubclasificacionEleccion: dataArticulo.subclasificacion === -2 
                                    ? undefined 
                                    : dataArticulo.subclasificacion,
                                tieneEmblema: dataArticulo.tipoArticulo === 1 //si es material no se carga si tiene emblema o no
                                    ? undefined
                                    : dataArticulo.tieneEmblema,
                                tipoEleccion: dataArticulo.idTipoEleccion === 0 
                                    ? undefined 
                                    : dataArticulo.idTipoEleccion,
                                justificacion: dataArticulo.justificacion,
                            })
                            if(dataArticulo.tipoArticulo == 1){//Si es Material no se requiere que se especifique si tiene emblema o no
                                setRequiredTieneEmblema(false);
                            }
                            //Se asigna la lista de especificacionesTecnicas
                            dataArticulo.especificacionesTecnicas.length > 0 && dataArticulo.especificacionesTecnicas.map(Item=>{
                               return addEspecificacionTec(Item.nombre);
                            })
                            //Se asigna la lista de especificaciones anexo 4.1
                            dataArticulo.especificacionesDisenio.length > 0 && dataArticulo.especificacionesDisenio.map(Item=>{
                               return addEspecificacionDis(Item.nombre);
                            })
                        })
                    });
                //Se verifica que la lista de subclasificaciones esté vacía para que no se ejecute varias veces la consulta
                if(listaSubclasificaciones.length <=0){
                    //Se obtiene la lista de subclasificaciones de acuerdo al tipo de Articulo obtenido
                    const listaSub= tiposSublcasificacion.filter(item => item.tipoArticulo === dataArticulo.tipoArticulo);
                    setListaSubclasificaciones(listaSub);
                }
                setLoadData(true);
            }).catch(error=>{
                console.log('ERROR',error)
            });
        }

    }

    const handleClose = () => {
        setVisibleAlert({
            activado: false,
            tipoMensaje: "",
            mensaje: ""
        });
    }
    const propsDisenioUnico = {
        multiple: false,
        fileList: fileList,
        onChange: file =>{
            if (file.fileList.length > 1) {
                setFileList([file.fileList[file.fileList.length - 1]]);
            } else {
                setFileList(file.fileList);
            }
        },
        onRemove: file => {
            setArchivoDisenioUnico(archivoDisenioU => {
                return {
                    file: archivoDisenioU.file
                };
            });
        },
        beforeUpload: file => {
            const isPDF = file.type === 'application/pdf';
            const isSomething = file.size > 0;
            const isSize = (file.size / 1024 / 1024) < 50; //Limita hasta 50 MB
            if (!isPDF) {
               message.error("El formato del archivo no corresponde a un PDF. Favor de borrarlo y cargar uno válido.",tiempoMensaje);
                return true;
            }
            if (!isSomething) {
                message.error("El archivo se encuentra vacío. Favor de borrarlo y cargar uno válido.",tiempoMensaje);
                return true;
            }
            if (!isSize) {
                message.error("El archivo pesa más de 50 MB. Favor de borrarlo y cargar uno válido.",tiempoMensaje);
                return false;
            }
            else {
                file.arrayBuffer().then(buff => {
                    let x = new Uint8Array(buff); // x is your uInt8Array
                    // perform all required operations with x here.
                    setArchivoDisenioUnico({
                        file: file,
                        urlPDF: x,
                        uploading: true,
                    });
                });
                console.log("call finished");
                message.success("El archivo fue cargado exitosamente",tiempoMensaje);
            }
            return false;
        },
        archivoDisenioUnico
    };

    const ListaEspecificaciones = function (props) {
        return (
            <div>
                    {[...props.especificaciones.keys()].map(k => (
                        <Row style={{marginBottom:'2px'}} key={k}>
                            <Col span={24}>
                                <Alert 
                                    style={{backgroundColor:'#E7E7E56e'}}
                                    type="default"
                                    closable
                                    onClose={()=>eliminaEspecif(k, props.tipo)}
                                    message={props.especificaciones.get(k)}/>
                            </Col>
                        </Row>
                    ))}
            </div>
        );
    }; 
    
    const eliminaEspecif = (especificacion, tipo) =>{
        let listaFiltrada = new Map();
        if (tipo === 'tec'){
            //Se filtra la lista
            listaEspTec.especificaciones.forEach((key, value) => {
              if (value !== especificacion) {
                //por alguna razón están invertidos el key y el value
                listaFiltrada.set(value, key);
              }
            });
            setListaEspTec({...listaEspTec, especificaciones: listaFiltrada})
        }else if ( tipo === 'dis'){
            //Se filtra la lista
            listaEspDis.especificaciones.forEach((key, value) => {
              if (value !== especificacion) {
                //por alguna razón están invertidos el key y el value
                listaFiltrada.set(value, key);
              }
            });
            setListaEspDis({...listaEspDis, especificaciones: listaFiltrada})
        }
    }
    //**************************************** */

    const handleTipoArticulo = event => {
        const valor = event.target.value;   
        //Se limpian los combos de clasificacion y subclasificacion
        props.form.resetFields([
            'tipoClasificacionEleccion',
            'tipoSubclasificacionEleccion'
        ])
        let data = {
            idProceso: procesoSel,
            idEstado: estadoSel,
            idDetalleProceso: detalleSel,
            idTipoArticulo: valor
        };
        getClasificacionesByTipoArt(data).then((res)=>{
            //se convierte el objeto que retorna el back en un array de objetos
            const objToArray = Object.entries(res.data.entity.select).map(([value, label]) => ({
                value,
                label
              }));
            setListaClasificaciones(objToArray);
        });
        const listaSub= tiposSublcasificacion.filter(item => item.tipoArticulo === valor);
        setListaSubclasificaciones(listaSub);
        
    };

    const handleChangeClasificacion = event =>{ 
        props.form.resetFields(['tipoEleccion'])
        getTiposEleccionByClasificacion(event).then(res=>{
            const objToArray = Object.entries(res.data.entity.select).map(([value, label]) => ({
                value,
                label
              }));
            setListaTiposEleccion(objToArray);
        })
    }

    function addEspecificacionTec(especificacion) {
        var timestamp = (new Date()).getTime();
        let idSpec = 'espTec-' + timestamp;
        setListaEspTec({
            especificaciones: listaEspTec.especificaciones.set(idSpec, especificacion)
        });
    }

    function addEspecificacionDis(especificacion) {
        var timestamp = (new Date()).getTime();
        let idSpec = 'espTec-' + timestamp;
        setListaEspDis({
            especificaciones: listaEspDis.especificaciones.set(idSpec, especificacion)
        });
    }
    function crearEspTec(e) {
        e.preventDefault();
        var espTec = props.form.getFieldValue('especif4-1');
        console.log(espTec)
        if (espTec !== null && espTec !=='' && espTec !== undefined) {
            addEspecificacionTec(espTec);
            props.form.resetFields(['especif4-1'])
        }
    }

    function crearEspDis(e) {     
        e.preventDefault();
        var espDis = props.form.getFieldValue('especifUnica');
        if (espDis !== null && espDis !=='' && espDis !== undefined) {
            addEspecificacionDis(espDis);
            props.form.resetFields(['especifUnica'])
        }
    }

    function handleGuardar(event) {
        event.preventDefault();
        const formData = new FormData();
        formData.append("idDetalleProceso", detalleSel);
        formData.append("idProcesoElectoral", procesoSel);  
        if (localStorage.getItem('ID_ESTADO_SELECCIONADO') !== 'null') {

            formData.append("idEstado", localStorage.getItem('ID_ESTADO_SELECCIONADO'));
        }
        else {
            console.log("ID_ESTADO_SELECCIONADO == null");
            formData.append("idEstado", localStorage.getItem('ID_ESTADO'));
        }
        formData.append("anio", localStorage.getItem('ANIO'));
        formData.append("tipoProceso", localStorage.getItem('TIPO_PROCESO'));
        const regex = /,/gi;

        let listaEspTecRequest = [];
        [...listaEspTec.especificaciones.keys()].map(k => (
            listaEspTecRequest = [...listaEspTecRequest, listaEspTec.especificaciones.get(k).replace(regex,'%coma%')]
        ))

        let listaEspDisRequest = [];
        [...listaEspDis.especificaciones.keys()].map(k => (
            listaEspDisRequest = [...listaEspDisRequest, listaEspDis.especificaciones.get(k).replace(regex,'%coma%')]
        ))
        //Se valida el formulario
        props.form.validateFields((err, values) => {
            if(!err){
                if (archivoDisenioUnico.file.length === 0) {
                    message.error("No hay un diseño único cargado, favor de cargarlo.",tiempoMensaje);
                }
                else if (listaEspTecRequest.length === 0) {
                        message.error("Debe haber al menos una especificación del anexo 4.1.",tiempoMensaje);
                }
                else if (listaEspDisRequest.length === 0) {
                        message.error("Debe haber al menos una especificación única.",tiempoMensaje);
                }else{
                    //Se agregan los datos al formData
                    formData.append("idArticulo", props.idArticulo);
                    formData.append("listaEspTec", listaEspTecRequest);
                    formData.append("listaEspDis", listaEspDisRequest);
                    formData.append("nombreArticulo", values.nombreArticulo);
                    formData.append("tipoArticulo", values.tipoArticulo);
                    formData.append("tipoClasificacionEleccion", values.tipoClasificacionEleccion);
                    formData.append("tipoSubclasificacionEleccion", values.tipoSubclasificacionEleccion);
                    if (values.tipoArticulo != 1){
                        formData.append("tieneEmblema", values.tieneEmblema);
                    }
                    formData.append("tipoEleccion", values.tipoEleccion);
                    formData.append("archivos[0].archivo", archivoDisenioUnico.file);
                    formData.append("justificacion", values.justificacion === undefined ? '' : values.justificacion);
                    //Se guardan los datos
                    updateArticulo(formData).then(response => {
                         if (response.data.entity.code === 200) {
                            if (response.data.entity.message !== null && response.data.entity.message !== "") {
                                message.warning(response.data.entity.message,tiempoMensaje);
                            }else {
                                message.success("Se actualizó correctamente el artículo", tiempoMensaje);
                            }
                             history.push('/configuracion/consultarcatalogos');
                         }else {
                             message.error("Ocurrió un error, trate más tarde", tiempoMensaje);
                             //localStorage.clear();
                             //window.location = "/login"
                         }
                     }).catch(error => {
                         console.log(error);
                        message.error("Ocurrio un error");
                        //if (error.response.status === 403) {
                        //    localStorage.clear();
                        //    window.location = "/login"
                        //    return;
                        //}
                     });
                }
            }else{
                message.error("Los datos con * son requeridos");
            }
        })
    };

    return (
        <div className="div_creararticulo">
            {visibleAlert.activado ?
                (
                    <Mensajes tipoMensaje={visibleAlert.tipoMensaje} mensaje={visibleAlert.mensaje} handleClose={handleClose} />
                ) : null}     
            <Form onSubmit={handleGuardar}>
                <Row>
                    <div className="div_titulo">
                        <Button id="regresar"
                            type="link"
                            href="/configuracion/consultarcatalogos">
                            <ArrowLeftOutlined />Regresar
                        </Button>
                    </div>
                    <Col span={24}>
                        <h1 id="titulo">Modificar registro de documento o material</h1>
                        <p id="msg">Los datos con (<span id="smsg">*</span>) son requeridos</p>
                    </Col>
                    <Row>
                        <Col span={8}>
                            <Form.Item label="Nombre del documento o material">
                            {getFieldDecorator('nombreArticulo', {
                                rules: [
                                    {required: true,message: 'Dato requerido'},
                                ],
                              })(
                                <Input
                                    placeholder="Ingresa el nombre del documento o material"
                                    type="text"
                                    maxLength={300}
                                />
                            )}  
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={16}>
                            <Form.Item label="Tipo de artículo a registrar">
                            {getFieldDecorator('tipoArticulo',{
                                rules: [
                                    {required: true,message: 'Dato requerido'},
                                ],
                            })(
                                <Radio.Group onChange={handleTipoArticulo}>
                                    <Radio value={1}> Material </Radio>
                                    <Radio value={2}> Documento</Radio>
                                </Radio.Group>
                            )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8}>  
                            <Form.Item label="Clasificación del documento o material">
                            {getFieldDecorator('tipoClasificacionEleccion', {
                                rules: [
                                    {required: true,message: 'Dato requerido'},
                                ],
                            })(
                                <Select 
                                    placeholder="Selecciona una opción"
                                    onChange={handleChangeClasificacion}
                                >
                                    {listaClasificaciones.map((item, index) => {
                                        return <Option key={index} value={parseInt(item.value)}>{item.label}</Option>
                                    })}
                                </Select>
                            )}
                            </Form.Item>          
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8}>
                            <Form.Item label="Subclasificación del documento o material">
                            {getFieldDecorator('tipoSubclasificacionEleccion', {
                                rules: [
                                    {required: true,message: 'Dato requerido'},
                                ]
                            })(
                                <Select placeholder="Selecciona una opción"> 
                                    {listaSubclasificaciones.map((item, index) => {
                                        return <Option key={index} value={item.value}>{item.label}</Option>
                                    })}
                                </Select>
                            )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={16}>
                            <Form.Item label="¿Tiene emblema el documento o material?">
                            {getFieldDecorator('tieneEmblema', {
                                rules: [
                                    {required: requiredTieneEmblema,message: 'Dato requerido'},
                                ]
                            })(
                                <Radio.Group> 
                                    <Radio value={1}> Sí </Radio>
                                    <Radio value={0}> No </Radio>
                                </Radio.Group>
                            )}
                            </Form.Item>    
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8}>
                            <Form.Item label="Tipo de Elección">
                            {getFieldDecorator('tipoEleccion', {
                                    rules: [
                                        {required: true,message: 'Dato requerido'},
                                    ]
                                })(
                                    <Select placeholder="Selecciona una opción"> 
                                        {listaTiposEleccion.map((item, index) => {
                                            return <Option key={index} value={parseInt(item.value)}>{item.label}</Option>
                                        })}
                                    </Select>
                            )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row span={24} style={{textAlign:'center'}} className="div_diseniounico">
                        <Col>
                            {loadData && archivoDisenioUnico.urlPDF!==null ? (
                                <Worker                               
                                    workerUrl={window.location.origin + "/pdf.worker.min.js"}
                                >
                                    <Col style={{ height: '750px', width: '900px' }}>
                                        <Viewer fileUrl={archivoDisenioUnico.urlPDF} />
                                    </Col>
                                </Worker>
                            ) :
                                (
                                    <Col
                                        style={{
                                            alignItems: 'center',
                                            border: '2px dashed rgba(0, 0, 0, .3)',
                                            display: 'flex',
                                            fontSize: '2rem',
                                            height: '100%',
                                            justifyContent: 'center',
                                            width: '100%',
                                        }}
                                    >
                                         Área de pre-visualización
                                    </Col>
                                )
                            }
                        </Col>
                        <Col span={4}>
                            <Upload id="subirDisUni" {...propsDisenioUnico} accept=".pdf">
                                <Tooltip title="Se permiten únicamente archivos en formato PDF">
                                <Button className="subir">
                                    <UploadOutlined />Subir
                                </Button>
                                </Tooltip>
                            </Upload>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={10}>
                            <Row>
                                <Col span={20}>
                                    <Form.Item label={<><span id="smsg">*</span>Especificaciones Anexo 4.1</>}>
                                    {getFieldDecorator('especif4-1', {
                                        })(
                                            <Input
                                              placeholder="Agrega una especificación"
                                            />,
                                    )}
                                    </Form.Item>
                                </Col>
                                <Col span={4} style={{position:'absolute', bottom:'0', right:0}}>
                                    <Form.Item>
                                        <Button icon="plus" className="agregar" type="primary" onClick={crearEspTec}>
                                          Agregar
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <ListaEspecificaciones especificaciones={listaEspTec.especificaciones} tipo='tec' />
                        </Col>
                        <Col span={10} offset={2}>
                            <Row>
                                <Col span={20}>
                                    <Form.Item label={<>
                                        <span id="smsg">*</span>Especificaciones Únicas</>}>
                                    {getFieldDecorator('especifUnica', {
                                        })(
                                            <Input
                                              placeholder="Agrega una especificación"
                                            />
                                    )}
                                     </Form.Item>
                                </Col>
                                <Col span={4} style={{position:'absolute', bottom:'0', right:0}}>
                                    <Form.Item>
                                        <Button icon="plus" className="agregar" type="primary" onClick={crearEspDis}>
                                          Agregar
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <ListaEspecificaciones especificaciones={listaEspDis.especificaciones} tipo='dis' />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item label="Justificación">
                            {getFieldDecorator('justificacion', {
                                
                                })(
                                    <TextArea rows={4}
                                        placeholder="Justifica la captura del nuevo documento o material"
                                        maxLength={150} 
                                    />
                            )}
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row className="div_botones_finales">
                        <Button className="cancelarc"
                            type="link"
                            href="/configuracion/consultarcatalogos"> Cancelar
                        </Button>

                        <Button type="primary" htmlType="submit" className="guardarc"> Guardar </Button>
                    </Row>
                </Row>
            </Form>
        </div>
    );

}
const formCrearArticulo = Form.create()(ModificarArticulo);
export default withRouter(formCrearArticulo);